"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EnumADLSelectMode = void 0;
/**
 * 通讯录选择的模式
 */
var EnumADLSelectMode;
(function (EnumADLSelectMode) {
    /**
     * 不可选部门，仅选用户
     */
    EnumADLSelectMode["onlyUser"] = "01";
    /**
     * 不可选用户，仅选部门
     */
    EnumADLSelectMode["onlyDept"] = "10";
    /**
     * 可选部门 + 用户
     */
    EnumADLSelectMode["BothUserAndDept"] = "11";
    /**
     * 选部门时选中部门下用户 + 用户
     */
    EnumADLSelectMode["UserUnderDept"] = "101";
})(EnumADLSelectMode = exports.EnumADLSelectMode || (exports.EnumADLSelectMode = {}));
//# sourceMappingURL=address-list.js.map